<template>
  <div class="tw-relative tw-w-full" v-if="variant === variants.v1 || variant === variants.v1Sidebar">
    <div class="tw-absolute tw-bottom-[0px] tw-h-[50%] tw-w-full lg:tw-h-[55%]" style="background-color: #7f338f"></div>
    <lazy-library-container class="tw-py-10 tw-pt-32 lg:tw-py-16">
      <div class="container text-center tw-mb-10">
        <h3>{{ vars.titleText }}</h3>
      </div>
      <div class="pxp-areas-carousel tw-mb-16 tw-mt-10 tw-px-0">
        <div class="pxp-areas-carousel-stage knowledge-hub-carousel-stage owl-carousel">
          <div
            v-for="guide in guides"
            :key="guide.id || guide.title"
            class="tw-group tw-cursor-pointer"
            @click.prevent="handleCardClick(guide)"
          >
            <div class="tw-relative tw-overflow-hidden">
              <library-image
                class="tw-h-full tw-w-full tw-object-contain tw-duration-500 group-hover:tw-scale-105"
                :src="guide.photo === null ? undefined : String(guide.photo)"
                :w-ratio="327"
                :h-ratio="420"
                :alt="guide.title"
              />
            </div>
            <div class="tw-h-[60px]">
              <h5 class="imageguide__title tw-mt-4 tw-line-clamp-2" style="color: var(--c-text_secondary) !important">
                {{ guide.title }}
              </h5>
            </div>
            <div class="mt-4">
              <button
                style="color: var(--c-text_secondary) !important"
                @click.stop="handleButtonClick(guide)"
                class="pxp-primary-cta text-uppercase pxp-animate after:!tw-border-white"
              >
                VIEW THIS GUIDE
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="tw-relative tw-z-10 tw-flex tw-items-center tw-justify-center">
        <nuxt-link :to="vars.buttonLinkUrl" :class="`n-${vars.buttonTypeText}`">
          {{ vars.buttonLabelText }}
        </nuxt-link>
      </div>
    </lazy-library-container>

    <popup v-if="selectedCard && popupConfig.isActive" :config="popupConfig" custom-width="90%">
      <template #content>
        <library-form
          v-if="selectedCard.formData"
          :form="selectedCard.formData"
          version="v2"
          :component="component"
          :custom-managed-form="managedFormVars"
        />
      </template>
    </popup>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { jQuery } from '~/public/theme3/js/vendor/custom';
import Popup from '~/components/common/popup/Popup.vue';

export default defineNuxtComponent({
  name: 'Theme3GuideSection',

  mixins: [ComponentMixin],

  components: { Popup },

  data() {
    return {
      variants: {
        v1: 'v1',
        v1Sidebar: 'v1Sidebar',
      },
      selectedCard: null,
      popupConfig: { isActive: false },
    };
  },

  computed: {
    guides() {
      return this.groupedVariables.guides;
    },

    managedFormVars() {
      return {
        isNeuronManagedFormBool: this.selectedCard.is_neuron_managed_form,
        formRedirectUrlText: this.selectedCard.form_redirect_url,
        formInternalTitleForCustomerText: this.selectedCard.form_internal_title_for_customer,
      };
    },
  },

  mounted() {
    if (this.variant === this.variants.v1Sidebar) {
      jQuery.knowledgeHubSliderSidebar();
    } else {
      jQuery.knowledgeHubSlider();
    }
  },

  methods: {
    handleCardClick(guide: any) {
      this.processCardAction(guide);
    },

    handleButtonClick(guide: any) {
      this.processCardAction(guide);
    },

    processCardAction(guide: any) {
      // form verisi farklı property'lerde olabilir, hepsini kontrol ediyoruz
      const rawForm = guide.guide || guide.form || guide.formData;

      if (!rawForm) {
        console.warn('No form data found for the guide:', guide);
        return;
      }

      const formData = this.parseFormV2(rawForm);
      if (!formData) return;

      this.selectedCard = { ...guide, formData };
      this.popupConfig.isActive = true;
    },
  },
});
</script>

<style scoped>
::v-deep(.pxp-areas-carousel-right-arrow) {
  top: 40% !important;
}

::v-deep(.pxp-areas-carousel-left-arrow) {
  top: 40% !important;
}

::v-deep(.knowledge-hub-variant-2 .pxp-areas-carousel-right-arrow) {
  top: 50% !important;
}

::v-deep .nc-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: unset !important;
  object-position: center;
  transition: transform 0.5s;
}

::v-deep(.knowledge-hub-variant-2 .pxp-areas-carousel-left-arrow) {
  top: 50% !important;
}

.knowledge-hub-variant-2 .pxp-primary-cta:after {
  border-color: var(--white);
}

.knowledge-hub-variant-2 .pxp-prop-card-1-fig:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.knowledge-hub-variant-2 .pxp-prop-card-1:hover .pxp-prop-card-1-fig:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(50, 205, 212, 0.3);
}
</style>
